export const LOGIN = 'Login'
export const SERVICES = 'Services'
export const SERVICES1 = 'Services1'
export const SERVICES2 = 'Services2'
export const WINGS = 'Wings'
export const DIVISION = 'Division'
export const OFFICE = 'Office'
export const PatientReportEndpoint = 'PatientReportData'
export const PatientOrdersEndpoint = 'PatientOrders'
export const CHARTS = 'GetCharts'
export const FollowUpBank = 'FollowUpBank'
export const MedicationMaster = 'MedicationMaster'
export const DELETEDIAGNOSIS = 'DeleteDiagnosis'
export const ALLWORKS = 'GetAllWorks'
export const ALLWORKSDATA = 'GetAllWorkData'
export const HOMECHARTS = 'GetHomeCharts'
export const PhysicalExaminationData = 'PhysicalExaminationData'
export const GetDiagnosis = 'GetDiagnosis'
export const FacilityAPI = 'FacilityCRUD'
export const FacilityDetailsCRUD = 'FacilityDetailsCRUD'
export const FetchFacilityAddress = 'FetchFacilityAddress'
export const ManageFormData = 'FormData'
export const GetPatientsFromKareo = 'GetPatientsFromKareo'
export const GetProviderOfKareo = 'GetProviderOfKareo'
export const SavePatientInformation = 'SavePatientInformation'
export const PatientMapCRUD = 'PatientMapCRUD'
export const PatientHistoryCRUD = 'PatientHistoryCRUD'
export const QuestionProvider = 'SaveQuestions'
export const FetchPatientData = 'FetchPatientData'
export const PatientInsurance = 'PatientInsurance'
export const PatientInternalNotesCRUD = 'PatientInternalNotesCRUD'
export const PatientPsychiatryNotesCRUD = 'PatientPsychiatryNotesCRUD'
export const ManageMedicine = 'ManageMedicine'
export const Labs = 'Labs'
export const ImagingCRUD = 'ImagingCRUD'
export const PatientPersonalHistoryCRUD = 'PatientPersonalHistoryCRUD'
export const PatientMedicationCrud = 'PatientMedicationData'
export const PatientImagingDataCrud = 'PatientImagingData'
export const PatientAllergyData = 'PatientAllergyData'
export const PatientLabsData = 'PatientLabsData'
export const PatientNoteData = 'PatientNoteData'
export const GetPatients = 'GetPatients'
export const SaveDiagnosis = 'SaveDiagnosis'
export const SaveRisks = 'SaveRisks'
export const SavePatient = 'SavePatient'
export const SavePatientDiagnosis_1 = 'SavePatientDiagnosis_1'
export const SavePatientDiagnosis = 'SavePatientDiagnosis'
export const QuesitonBank = 'QuesitonBank'
export const ProviderBank = 'ProviderBank'
export const ProviderCredentialingCRUD = 'ProviderCredentialingCRUD'
export const ProviderOnboardingCRUD = 'ProviderOnboardingCRUD'
export const GetPatientDiagnosis = 'GetPatientDiagnosisDetails'
export const HOMECHARTSDATA = 'GetHomeChartsData'
export const GetKeywords = 'GetKeywords'
export const ManageUser = 'ManageUser'
export const CHARTSWITHFILTER = 'GetChartsWithFilter'
export const ChartTableDetails = 'ChartTableDetails'
export const CHILDTABLEDETAILS = 'ChildTableDetails'
export const Filters = 'GetFilters'
export const Modules = 'GetModules'
export const GETDATA = 'GetData'
export const FacilityType = 'FacilityType'
export const ApplicationType = 'ApplicationType'
export const FacilityLogin = 'ManageFacilityLogin'
export const FetchServiceLocations = 'FetchServiceLocations'
export const GetAllAppointments = 'GetAllAppointments'
export const CreateAppointment = 'CreateAppointment'
export const UpdateAppointment = 'UpdateAppointment'
export const SaveExtraData = 'SaveExtraData'
export const PatientSuperBill = 'PatientSuperBill'
export const AppointmentData = 'AppointmentData'
export const BoardCRUD = 'BoardCRUD'
export const TaskCRUD = 'TaskCRUD'
export const EmployeeLeaveCRUD = 'EmployeeLeaveCRUD'
export const HolidayCalendarCRUD = 'HolidayCalendarCRUD'
export const EmployeeDetailsCRUD = 'EmployeeDetailsCRUD'
export const NotificationCRUD = 'NotificationCRUD'
export const GetDashboardTasks = 'GetDashboardTasks'

// //export const FILTER_URL = 'http://localhost:50252/webservice/Filters.asmx'
//export const BASE_URL = 'http://localhost:50252/webservice/Charts.asmx'

// export const FILTER_URL = 'https://103.27.120.198/provioWS/webservice/Filters.asmx'
// export const CHARTS_URL = 'https://103.27.120.198/provioWS/webservice/Charts.asmx'
// export const DATAWAREHOUSE_URL = 'https://103.27.120.198/provioWS/webservice/Datawarehouse.asmx'
// export const BASE_URL = 'https://103.27.120.198/provioWS/webservice/Charts.asmx'

export const FILTER_URL = 'https://103.27.120.199/provioWS/webservice/Filters.asmx'
export const CHARTS_URL = 'https://103.27.120.199/provioWS/webservice/Charts.asmx'
export const DATAWAREHOUSE_URL = 'https://103.27.120.199/provioWS/webservice/Datawarehouse.asmx'
export const BASE_URL = 'https://103.27.120.199/provioWS/webservice/Charts.asmx'

//http://122.179.135.100/
// export const BASE_URL = 'http://localhost:50252/webservice/Charts.asmx'
// export const FILTER_URL = 'http://localhost:50252/webservice/Filters.asmx'
// export const CHARTS_URL = 'http://localhost:50252/webservice/Charts.asmx'
// export const DATAWAREHOUSE_URL = 'http://localhost:50252/webservice/Datawarehouse.asmx'


// export const FILTER_URL = 'https://103.27.120.198/provioTestWS/webservice/Filters.asmx'
// export const CHARTS_URL = 'https://103.27.120.198/provioTestWS/webservice/Charts.asmx'
// export const DATAWAREHOUSE_URL = 'https://103.27.120.198/provioTestWS/webservice/Datawarehouse.asmx'
// export const BASE_URL = 'https://103.27.120.198/provioTestWS/webservice/Charts.asmx'